module.exports = __webpack_public_path__ + "static/media/3.f0004277.mp3";